module.exports = __webpack_public_path__ + "05_mid_yellow.9ee51758.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_mid_yellow.png
// module id = gpMo
// module chunks = 0